/**
* Convert string in float number.
*/
export function filterFloat(value: string): number {
	if (/^([-+])?(\d+([.]\d+)?)$/.test(value))
		return Number(value);
	return Number.NaN;
};

/**
* Convert string in decimal number.
*/
export function convertToDecimal(value: string | null): number | null {
	return value && /^([-+])?(\d+([.,]\d+)?)$/.test(value) ? Number.parseFloat(value.replace(",", ".")) : null;
}

/**
* Trunc decimal number with two decimal digits.
*/
export function truncDecimal(value: string | null): string | null {
	if (value == null) return null;
	const decimal = value;
	if (/^(\d+[.]\d+)$/.test(decimal)) {
		return decimal.substring(0, decimal.indexOf(".") + 2);
	} else if (/^(\d+,\d+)$/.test(decimal)) {
		return decimal.substring(0, decimal.indexOf(",") + 2);
	} else {
		return decimal;
	}
}

/**
* Convert decimal number in string.
*/
export function printDecimal(value: number, digits: number): string {
	return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: digits }).format(value);
}

/**
* Convert mass measure from a unit to other one.
*/
export function convertMass(value: number | null, unit: 'kg' | 'lb'): number | null {
	const LB_PER_KG = 2.20462;
	if (value == null) return null;
	if (unit === 'kg') {
		return Number.parseFloat((value * LB_PER_KG).toFixed(1)); // kg → lb
	} else if (unit === 'lb') {
		return Number.parseFloat((value / LB_PER_KG).toFixed(1)); // lb → kg
	} else {
		throw new Error("Invalid unit. Use 'kg' or 'lb'.");
	}
}

/**
* Convert length measure from a unit to other one.
*/
export function convertLength(value: number | null, unit: 'cm' | 'ft'): number | null {
	const CM_PER_FOOT = 30.48;
	if (value == null) return null;
	if (unit === 'cm') {
		return Number.parseFloat((value / CM_PER_FOOT).toFixed(1)); // cm → ft
	} else if (unit === 'ft') {
		return Number.parseFloat((value * CM_PER_FOOT).toFixed(1)); // ft → cm
	} else {
		throw new Error("Invalid unit. Use 'cm' or 'ft'.");
	}
}
